export default __webpack_public_path__ + "static/media/license-bg-mobile-cn.0c3420cb.webp";